import { render } from "./ItemBulkEdit.vue?vue&type=template&id=cf7f1bfa&scoped=true"
import script from "./ItemBulkEdit.vue?vue&type=script&lang=js"
export * from "./ItemBulkEdit.vue?vue&type=script&lang=js"

import "./ItemBulkEdit.vue?vue&type=style&index=0&id=cf7f1bfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf7f1bfa"]])

export default __exports__